import React from "react";
import styles from "./AboutMe.module.css";
import { SocialIcons } from "../Icons/Icons";
import photo1 from "../assets/photos/cres.jpeg";
import photo2 from "../assets/photos/zagreb.jpeg";
import photo3 from "../assets/photos/panda.jpeg";
import photo4 from "../assets/photos/osito.jpg";
import photo5 from "../assets/photos/oso.jpg";
import photo6 from "../assets/photos/pika.jpg";
import yarn from "../assets/yarn_red.svg";
import hook from "../assets/logo/ganchillo.svg";

import { BsInstagram, BsFacebook, BsMailbox } from "react-icons/bs";

function AboutMe() {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <h2>¡Hola! Bienvenido a Paw Paw Needle</h2>
        <p>
          Soy Guadalupe, la persona detrás de este emprendimiento. Soy una
          argentina viviendo en España y con muchas ganas de contagiar mi amor
          por lo tejido.
        </p>
        <figure className={styles.figure}>
          <img
            src={photo1}
            alt="Tejiendo en Cres"
            className={styles.photo}
          ></img>
        </figure>
        <p>
          Antes de llegar a mi nuevo hogar en España estuve viajando un tiempo y
          las vueltas de la vida me llevaron a Croacia, el país en donde nació
          la idea de Paw Paw Needle. Llegué a Zagreb a mediados del 2022 y en el
          2023, después de algunos meses difíciles por todo lo que significó
          internamente estar lejos de mi familia, volví a agarrar el ganchillo.
          ¡Qué bien me hizo!
        </p>
        <p>
          Volver a tejer me permitió conocer gente con la que pude compartir
          lindas tardes. Me uní a un club de crochet. Todos los sábados tomaba
          un café entre lanas, podía ver los progresos de mis compañeras y
          mostrar los míos. Este grupo me ayudó a entender que el crochet no
          tiene porque ser una actividad en solitario (por lo menos cuando no
          requiere toda nuestra atención contar puntos) e hizo que crecieran
          mucho más mis ganas de crochetear y compartir todo lo que hacía. Creé
          Paw Paw Needle en Instagram con el único fin de compartir mis
          proyectos y llevar un registro de lo que iba haciendo.
        </p>
        <figure className={styles.figure2}>
          <img
            src={photo2}
            alt="Mi parque favorito de Zagreb"
            className={styles.photoExtra}
          ></img>
        </figure>
        <p>
          Tejer acompañada y mi familia (que hace años me vienen diciendo que
          venda mis creaciones) me impulsaron a pensar que Paw Paw podría ser
          algo más. Así que decidí comenzar este pequeño emprendimiento, con más
          dudas que certezas, con muchas cosas que aprender y mejorar, también
          con un poco de miedo, pero feliz de haber iniciado este nuevo camino.
        </p>
        <p>
          Mi amistad con el ganchillo y las agujas empezó hace mucho. El arte y
          las lanas estuvieron presentes en mi vida desde que era pequeña.
          Siempre me gustó crear con mis propias manos. Estoy segura de que cada
          integrante de mi familia recibió una carta super decorada o alguna
          manualidad para su cumpleaños. Pero el mundo de las lanas e hilos
          tiene un lugar especial en mi corazón. El ganchillo me lleva a
          recordar a mis abuelas, a esos momentos en que me enseñaban a sostener
          las agujas y las primeras frustraciones al aprender los puntos
          básicos. Aunque las fotografías de esos momentos se mezclen o pierdan
          entre otros recuerdos, la sensación de calidez y de amor no las podría
          olvidar jamás.{" "}
        </p>
        <div className={styles.before}>
          <div className={styles.photos}>
            <figure className={styles.oldContainer}>
              <img
                src={photo3}
                alt="Viejo proyecto"
                className={styles.old1}
              ></img>
            </figure>
            <figure className={styles.oldContainer}>
              <img
                src={photo4}
                alt="Viejo proyecto"
                className={styles.old}
              ></img>
            </figure>
            <figure className={styles.oldContainer}>
              <img
                src={photo5}
                alt="Viejo proyecto"
                className={styles.old}
              ></img>
            </figure>
            <figure className={styles.oldContainer}>
              <img
                src={photo6}
                alt="Viejo proyecto"
                className={styles.old}
              ></img>
            </figure>
          </div>

          <p>
            Amigurumis que hice hace algunos (muchos) años atrás 😍 El panda fue
            mi primer amigurumi
          </p>
        </div>
        <p>
          Esa ternura y calidez es la que espero que tengan todas mis creaciones
          y lleguen a vos. Gracias por leer e interesarte en Paw Paw. Deseo con
          todo mi corazón que los productos de Paw Paw Needle te acompañen en
          algún momento especial.
        </p>
      </div>

      <div className={styles.tarjeta}>
        <h3>Hablemos</h3>
        <p>Podés econtrarme en Instagram y Facebook o enviarme un mail.</p>

        <div className={styles.social}>
          <SocialIcons
            href="https://www.instagram.com/pawpawneedle/"
            icon={<BsInstagram></BsInstagram>}
          ></SocialIcons>
          <SocialIcons
            href="https://www.facebook.com/pawpawneedle"
            icon={<BsFacebook></BsFacebook>}
          ></SocialIcons>
          <SocialIcons
            href="mailto:pawpawneedle@gmail.com"
            icon={<BsMailbox></BsMailbox>}
          ></SocialIcons>
        </div>
        <img src={hook} alt="hook" className={styles.hook}></img>
      </div>
      <img src={yarn} alt="line" className={styles.yarn}></img>
    </div>
  );
}
export { AboutMe };
